import React from 'react';

import {
  renderTestOrderAssayChip,
  renderTestOrderContainerChip,
  renderTestOrderSample,
  renderTestOrderTestDefinitionChip,
  renderTestOrderWorksheetChip,
  renderTestOrderAnalysisComment,
  renderTestOrderDilutionFactor,
  renderTestOrderStudies,
} from 'sample-tests/ui/utils/testOrderChipsUtil';
import {TestOrderStatusDisplay} from 'sample-tests/ui/utils/TestOrderStatusUtil';
import {ChipSize} from 'ui-library/chips/Chip';
import ChipPopoverContent from 'ui-library/chips/ChipPopoverContent';
import {DatetimeTableCell} from 'ui-library/scrollable/table-cells/DatetimeTableCell';

import {TestOrderChipGraphQL} from '../../../../../graphql-fragments/sample_tests/__generated/TestOrderChipGraphQL';

interface Props {
  /** Whether the test order is accessible to the current user */
  isInaccessible: boolean | undefined;
  /** The test order summary, if we already have it */
  testOrder?: TestOrderChipGraphQL;
}

export function TestOrderChipPopoverContent(props: Props): JSX.Element | null {
  const {testOrder, isInaccessible} = props;

  if (testOrder == null) {
    return null;
  } else if (isInaccessible) {
    return <>(No access)</>;
  }

  const useNAText = true;

  const fields = [
    {label: 'Name', value: testOrder.name},
    {label: 'Sample', value: renderTestOrderSample(testOrder)},
    {label: 'Status', value: <TestOrderStatusDisplay status={testOrder.status} />},
    {label: 'Analysis comment', value: renderTestOrderAnalysisComment(testOrder, {useNAText})},
    {
      label: 'Container',
      value: renderTestOrderContainerChip(testOrder, ChipSize.MINI, {useNAText}),
    },
    {label: 'Dilution factor', value: renderTestOrderDilutionFactor(testOrder, {useNAText})},
    {
      label: 'Test definition',
      value: renderTestOrderTestDefinitionChip(testOrder, ChipSize.MINI),
    },
    {label: 'Assay', value: renderTestOrderAssayChip(testOrder, ChipSize.MINI, {useNAText})},
    {label: 'Worksheet', value: renderTestOrderWorksheetChip(testOrder, ChipSize.MINI, {useNAText})},
    {
      label: 'Studies',
      value: renderTestOrderStudies(testOrder, {useNAText}),
    },
    // Note, Result is not rendered here because it is rendunant for places where this chip will be visible
    {label: 'Created at', value: <DatetimeTableCell datetime={testOrder.createdAt} showTimeInCell={false} />},
    {
      label: 'Modified at',
      value: <DatetimeTableCell datetime={testOrder.modifiedAt} showTimeInCell={false} />,
    },
  ];

  return <ChipPopoverContent info={{fields}} />;
}
